import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorOccurredWithLink: {
		id: 'project-create-importer-upload-flow.select-third-party-entity-screen.entity-stats.error-occurred-with-link',
		defaultMessage: "We couldn't load the data. <link>Try again</link>",
		description: 'Error message when the entity data could not be loaded',
	},
	entityStatsUserMessage: {
		id: 'project-create-importer-upload-flow.select-third-party-entity-screen.entity-stats.entity-stats-user-message',
		defaultMessage: 'Users won’t get an email when they’re added to Jira.',
		description:
			'Info message to indicate that users will not get emailed when they are added to the project',
	},
});
